import { connect } from "react-redux";
import { GetDataMenuAllAction, GetDataRolesAllAction, GetDataMenuRolesAction, SetDataMenuRolesAction, DeleteDataMenuRolesAction, SetDataMenuAction } from "../actions";
import { MenuRoleComponent } from "../components";

const mapStateToProps = state =>{
    return {
        ...state,
        DataMenu: state.allMenuRoleReducer.menuReducer.DataMenu,
        DataRoles: state.allMenuRoleReducer.roleReducer.DataRoles,
        DataMenuRoles: state.allMenuRoleReducer.menuRoleReducer.DataMenuRoles,
        isResult: state.allMenuRoleReducer.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch =>{
    return {
        GetDataMenuAll: () => {
            dispatch(GetDataMenuAllAction());
        },
        GetDataRolesAll: () =>{
            dispatch(GetDataRolesAllAction());
        },
        GetDataMenuRoles: () =>{
            dispatch(GetDataMenuRolesAction());
        },
        SetDataMenuRoles: (DataMenuRoles) => {
            dispatch(SetDataMenuRolesAction(DataMenuRoles));
        },
        DeleteDataMenuRoles: (DataDelete) =>{
            dispatch(DeleteDataMenuRolesAction(DataDelete));
        },
        SetDataMenu: (DataMenu) =>{
            dispatch(SetDataMenuAction(DataMenu));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuRoleComponent);